import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { FieldFilterType } from "../../../../base/types";
import { IChoices } from "./assessment";

export const useGetChoices = (questionId: string) => {
    const { user, siteId } = useAuth();
    const [getRecords] = useLazyReadMultipleQuery();
    const [choices, setChoices] = useState<IChoices[]>([]);

    useEffect(() => {
        if (questionId) {
            getChoices();
        }
        // eslint-disable-next-line
    }, [questionId]);

    const getChoices = (): Promise<void> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.');
        }

        return getRecords({
            userId: user?.contactId || '',
            portalId: siteId || '',
            tableId: "edtec365_choices",
            fieldList: ["edtec365_name", "edtec365_choicesid"],
            filters: [{
                group: 0, filters: [
                    { field: "edtec365_question", type: FieldFilterType.Const, value: questionId }
                ]
            }]
        }).unwrap().then((data) => {

            const questionsRecords = data.records.map(record => ({
                choiceid: record["edtec365_choicesid"] as string,
                name: record["edtec365_name"] as string,
            }));

            setChoices(questionsRecords);
        }).catch(error => {
            console.error('Error fetching questions:', error);
        });
    };
    return { choices };
};
